import { render, staticRenderFns } from "./PcIntro.vue?vue&type=template&id=4b945e8a&"
import script from "./PcIntro.vue?vue&type=script&lang=js&"
export * from "./PcIntro.vue?vue&type=script&lang=js&"
import style0 from "./PcIntro.vue?vue&type=style&index=0&id=4b945e8a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports